module.exports = "/_next/static/images/fc62895492caaab635a9f0e8968c3763-sparkles-purple.svg";